'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {renderLocationText} from '../../utils/locationUtils';
import {TimerLogItemView} from './TimerLogItemView';

export class TimerLogItemComponent extends Component {
  static propTypes = {
    model: T.object.isRequired,
  };

  render() {
    const model = this.props.model;
    const locationText = model.locCap ? renderLocationText(model.loc, model.geo) : '';

    return (
      <TimerLogItemView
        className={this.props.className}
        by={model.by}
        isPreview={model.isPreview}
        start={model.start}
        end={model.end}
        isLocationCaptured={model.locCap}
        isLocationExpected={Boolean(model.geo)}
        location={locationText}
        byName={model.byName}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/components/TimerLogItem/TimerLogItemComponent.js